import React, { useState, useCallback } from "react";
import * as Scrivito from "scrivito";
import { Button, Form } from "reactstrap";
import { PasswordInput } from "components";

const SetPassView = Scrivito.connect(({ page }) => {
  const [newPass, setNewPass] = useState("");
  const [newPassRep, setNewPassRep] = useState("");

  const handleSetNewPass = async (event) => {
    event.preventDefault();
    // TODO: No endpoint from DS yet
  };

  const handleNewPassChange = useCallback((e) => {
    setNewPass(e.target.value);
  }, []);

  const handleNewPassRepChange = useCallback((e) => {
    setNewPassRep(e.target.value);
  }, []);

  // TODO: temp vars - to remove when we receive the proper endpoint
  const setPassErr = null;
  const isSetNewPassPending = false;

  return (
    <Form
      className="bg-white col-md-6 mx-auto p-0 d-flex flex-column"
      data-testid="set-pass-view"
      onSubmit={handleSetNewPass}
    >
      <div className="p-4 font-size-md">
        <Scrivito.LinkTag
          data-testid="SetPassView_login-link"
          className="text-secondary"
          to={page}
          params={{ view: "login" }}
        >
          <span className="fal fa-angle-left"> </span>
          <Scrivito.ContentTag
            tag="span"
            attribute="backToLoginBtn"
            content={page}
          />
        </Scrivito.LinkTag>
      </div>
      <div className="col-md-11 mx-auto text-start">
        <Scrivito.ContentTag
          tag="h1"
          content={page}
          attribute="setPassHeader"
        />
        <Scrivito.ContentTag
          tag="p"
          content={page}
          attribute="setPassDescription"
        />
        <PasswordInput
          value={newPass}
          label={page.get("newPassFieldLabel")}
          error={setPassErr}
          name="newPassField"
          id="newPassFieldId"
          testId="newPass"
          onChange={handleNewPassChange}
          classNames="mb-0"
        />
        <PasswordInput
          value={newPassRep}
          label={page.get("newPassRepFieldLabel")}
          error={setPassErr}
          name="newPassRepField"
          id="newPassRepFieldId"
          testId="newPassRep"
          onChange={handleNewPassRepChange}
          classNames="mb-0"
        />
        <div className="row m-0">
          {setPassErr && (
            <div className="col-md-16 p-0 text-start text-danger">
              {`${page.get("errorOccured")}: ${setPassErr}`}
            </div>
          )}
          {newPass && newPassRep && newPass !== newPassRep && (
            <Scrivito.ContentTag
              attribute="errorPasswordsDiffer"
              content={page}
              className="col-md-16 p-0 text-start text-danger"
            />
          )}
        </div>
        <div className="text-end mt-5 mb-6">
          <Button
            data-testid="SetPassView_set-pass-btn"
            type="submit"
            disabled={isSetNewPassPending}
            color="primary"
            className="ms-3 my-3"
          >
            <Scrivito.ContentTag attribute="setPassButton" content={page} />
          </Button>
        </div>
      </div>
    </Form>
  );
});

export default SetPassView;
